import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomValidators } from 'ng2-validation';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BaseUserService } from '../../services/base-user/base-user.service';
import { STRONG_PASSWORD_REGEX } from '../../util/regex/_constants/strong-password.regex';

/**
 * A component to reset a password
 */
@Component({
  selector: 'lm-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  /** The component's form group */
  public resetPasswordForm: FormGroup;

  /** Boolean indicating whether the token is valid */
  public validToken: boolean;

  /** The error message to display */
  public errorMessage: string;

  /** The ID of the user requesting the password change */
  private userId: string;

  /** The password reset token */
  private token: string;

  /**
   *
   * @param formBuilder - A reference to the FormBuilder service
   * @param activatedRoute - The activated route
   * @param router - The router
   * @param matSnackBar - A reference to the MatSnackBar service
   * @param baseUserService - A reference to the base user service
   */
  constructor(
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private matSnackBar: MatSnackBar,
    private baseUserService: BaseUserService
  ) {}

  /**
   * Method called when the component is initialized
   */
  public async ngOnInit() {
    this.token = this.activatedRoute.snapshot.queryParamMap.get('token');
    const response = await this.baseUserService._validatePasswordResetToken(
      this.token
    );
    if (response.validToken === true) {
      this.validToken = true;
      this.userId = response.userId;
    } else {
      this.validToken = false;
      this.errorMessage = response.message;
      this.userId = null;
    }
    this.resetPasswordForm = this.formBuilder.group({
      password: [
        '',
        [Validators.required, Validators.pattern(STRONG_PASSWORD_REGEX)]
      ],
      passwordVerify: ['', []]
    });
    this.resetPasswordForm
      .get('passwordVerify')
      .setValidators([
        Validators.required,
        CustomValidators.equalTo(this.resetPasswordForm.get('password'))
      ]);
  }

  /**
   * Method called when the user clicks the submit button
   */
  public async onSubmit() {
    const newPassword = this.resetPasswordForm.value.password;
    const result = await this.baseUserService._resetPassword(
      this.token,
      this.userId,
      newPassword
    );

    const delay = ms => new Promise(res => setTimeout(res, ms));
    this.matSnackBar.open('Your password was successfully reset');
    await delay(3000);
    this.router.navigate(['/']);
  }
}
